import React from 'react';
export function ProblemSection() {
  const problems = ['Tu sueldo nunca alcanza y dependes de un trabajo que no te llena', 'Ves a otras ganar en TikTok pero no sabes por dónde empezar', 'Gastaste en cursos caros que solo te dejaron más confundida', 'No tienes tiempo para algo complicado entre trabajo, casa y familia'];
  return <section className="section-spacing bg-gradient-warm" data-id="element-449">
      <div className="container-narrow" data-id="element-450">
        <div className="text-center mb-8" data-id="element-451">
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-black text-deep-cocoa mb-3" data-id="element-452">
            ¿Te identificas con esto?
          </h2>
          <p className="text-base text-deep-cocoa/70" data-id="element-453">
            Si respondiste "sí" a cualquiera, esta guía es para ti
          </p>
        </div>

        <div className="grid sm:grid-cols-2 gap-4 max-w-3xl mx-auto" data-id="element-454">
          {problems.map((problem, index) => <div key={index} className="bg-white rounded-xl p-4 shadow-soft border-l-4 border-accent-urgency/30 animate-fade-in-up" style={{
          animationDelay: `${index * 100}ms`
        }} data-id="element-455">
              <p className="text-deep-cocoa/90 text-sm leading-relaxed" data-id="element-456">
                {problem}
              </p>
            </div>)}
        </div>

        <div className="mt-8 text-center" data-id="element-457">
          <div className="inline-block bg-white rounded-xl px-6 py-4 shadow-medium" data-id="element-458">
            <p className="text-lg font-bold text-deep-cocoa mb-1" data-id="element-459">
              La buena noticia:
            </p>
            <p className="text-base text-deep-cocoa/80" data-id="element-460">
              Hay una solución simple, rápida y económica 👇
            </p>
          </div>
        </div>
      </div>
    </section>;
}